import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Button, Input, Pagination, Select, Spin } from "antd";
import CountUp from "react-countup";
import { Message, ViewInput } from "../../../GlobalStyles";
import { useAuth } from "../../../hooks/AuthContext";

export default function ServicesCliente() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [servicesBackup, setServicesBackup] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterSector, setFilterSector] = useState("");
  const [filterCollaborators, setFilterCollaborators] = useState("");

  useEffect(() => {
    listServices();
  }, []);

  async function listServices() {
    setLoading(true);
    await api
      .get(`/services-client`)
      .then((response) => {
        setServices(response.data.services);
        setServicesBackup(response.data.services);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Serviços</h1>
      <Card>
        <p>Total</p>
        <CountUp separator="." duration={1} end={services.length} />
      </Card>
      <div className="filter">
        <ViewInput style={{ width: 250, marginRight: 15 }}>
          <p>Setor</p>

          <Select
            style={{ width: "100%", textAlign: "left" }}
            placeholder="seleciona uma opção"
            value={filterSector || null}
            onChange={(value) => {
              setFilterSector(value);
            }}
          >
            {!user.signature && (
              <Select.Option value="Serviços de segurança do Trabalho">
                Serviços de segurança do Trabalho
              </Select.Option>
            )}

            {!user.signature && (
              <Select.Option value="Revenda de treinamentos online">
                Revenda de treinamentos online
              </Select.Option>
            )}

            {!user.signature && (
              <Select.Option value="Serviços Medicina ocupacional">
                Serviços Medicina ocupacional
              </Select.Option>
            )}

            {!user.signature && (
              <Select.Option value="Credenciamento SST">
                Credenciamento SST
              </Select.Option>
            )}

            <Select.Option value="Assinatura Documentos SST">
              Assinatura Documentos SST
            </Select.Option>
          </Select>
        </ViewInput>
        <ViewInput style={{ width: 250, marginRight: 15 }}>
          <p>Pesquisar por nome</p>
          <Input
            value={filterName}
            onChange={(text) => {
              setFilterName(text.target.value);
            }}
            placeholder="pesquisar"
            allowClear
            onClear={() => {
              setFilterName("");
            }}
          />
        </ViewInput>
        <ViewInput style={{ width: 150, marginRight: 15 }}>
          <p>Colaboradores</p>
          <Input
            value={filterCollaborators}
            onChange={(text) => {
              setFilterCollaborators(parseInt(text.target.value) || "");
            }}
            placeholder="pesquisar"
            allowClear
            onClear={() => {
              setFilterCollaborators("");
            }}
          />
        </ViewInput>
        <Button
          type="primary"
          style={{
            marginTop: 17,
            marginLeft: 5,
            borderRadius: 50,
          }}
          onClick={() => {
            let servicesNew = servicesBackup;
            if (filterSector) {
              servicesNew = servicesNew.filter((item) => {
                return item.sector == filterSector;
              });
            }
            if (filterCollaborators) {
              servicesNew = servicesNew.filter((item) => {
                return (
                  (!item.min_collaborators ||
                    item.min_collaborators <= filterCollaborators) &&
                  (!item.max_collaborators ||
                    item.max_collaborators >= filterCollaborators)
                );
              });
            }
            if (filterName) {
              servicesNew = servicesNew.filter((item) => {
                return item.name
                  .toUpperCase()
                  .includes(filterName.toUpperCase());
              });
            }
            setServices(servicesNew);
          }}
        >
          Filtrar
        </Button>
      </div>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          {services.length == 0 && <Message>Nenhum serviço encontrado</Message>}
          <div className="services">
            {services.map((item) => {
              return (
                <div className="service">
                  <div>
                    <p>
                      {item.name} - Setor: {item.sector}
                    </p>
                    <p style={{ color: "#000a", marginTop: 2 }}>
                      - Valor do Serviço:{" "}
                      {item.value.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                    <p style={{ color: "#000a", marginTop: 2 }}>
                      - Valor do Sugerido:{" "}
                      {(item.value * 3).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                    {(!!item.min_collaborators || !!item.max_collaborators) && (
                      <p style={{ color: "#000a", marginTop: 2 }}>
                        {!!item.min_collaborators &&
                          `- Min de colaboradores: ${item.min_collaborators} `}
                        {!!item.max_collaborators &&
                          `- Máx de colaboradores: ${item.max_collaborators}`}
                      </p>
                    )}
                    {item.description && (
                      <p style={{ color: "#000a", marginTop: 2 }}>
                        - {item.description}
                      </p>
                    )}
                    <p style={{ color: item.required_company ? "#d48806" : "#8c8c8c", marginTop: 2, fontSize: 12, fontWeight: "600" }}>
                      - Vincular Formulário: {item.required_company ? "Obrigatório" : "Não obrigatório"}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </Container>
  );
}
